// apps/client/src/game/instance.ts — the one Game per page, and the bridge from screens to it (§8.2 step 5)
import type { GameCommands } from './game';
import { Game } from './game';
import { useGame } from '../state/store';

let game: Game | null = null;
/** Lazy singleton: created on first use (the first town entry), never before. */
export function getGame(): Game { return (game ??= new Game()); }
/** The Game if one exists, without creating it (UI that only reads, such as the town clock for relative times). */
export function peekGame(): Game | null { return game; }
/** The command API for React components. */
export function useCommands(): GameCommands { return getGame().cmd; }
/** main.tsx calls this once: screens ask with requestEnterTown(id); the game does the rest (§8.2 step 5). `get` is a test seam. */
export function installGameBridge(get: () => { cmd: Pick<GameCommands, 'enterTown'> } = getGame): () => void {
  const take = (id: ReturnType<typeof useGame.getState>['enterTownRequest']) => {
    if (!id) return;
    useGame.getState().clearEnterTownRequest();
    void get().cmd.enterTown(id);
  };
  take(useGame.getState().enterTownRequest);                     // a request made before the bridge was installed
  return useGame.subscribe((s) => take(s.enterTownRequest));
}
